import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Components/About';
import Resume from './Components/Resume';
import Contact from './Components/Contact';
import Recommendations from './Components/Recommendations';

const App = () => {
  const [state, setState] = useState(null);
  const [language, setLanguage] = useState(() => localStorage.getItem('language') || 'pt');

  useEffect(() => {
    async function fetchUserData() {
      const response = await fetch("/resumeData.json");
      setState(await response.json());
    }

    fetchUserData();
  }, []);

  useEffect(() => {
    if (!state) return;

    const content = state[language];
    document.documentElement.lang = language === 'pt' ? 'pt-BR' : 'en';
    document.title = content.meta.title;
    const description = document.querySelector('meta[name="description"]');
    const openGraphTitle = document.querySelector('meta[property="og:title"]');
    const openGraphDescription = document.querySelector('meta[property="og:description"]');

    if (description) description.setAttribute('content', content.meta.description);
    if (openGraphTitle) openGraphTitle.setAttribute('content', content.meta.title);
    if (openGraphDescription) openGraphDescription.setAttribute('content', content.meta.description);
    localStorage.setItem('language', language);
  }, [language, state]);

  if (!state) {
    return "";
  }

  const content = state[language];

  return (
    <div className="App">
      <Header data={content.main} ui={content.ui} language={language} onLanguageChange={setLanguage} />
      <About data={content.main} ui={content.ui} />
      <Resume data={content.resume} ui={content.ui} />
      <Recommendations data={content.recommendations} ui={content.ui} />
      <Contact data={content.main} ui={content.ui} />
      <Footer data={content.main} ui={content.ui} />
    </div>
  );
}

export default App;
